/* eslint-disable import/prefer-default-export */
import { EuiFlexGroup } from "@elastic/eui";
import styled from "styled-components";

export const TripFinancialsWrapper = styled(EuiFlexGroup)`
    padding: 16px;
    gap: 16px;
`;
export const TripPiceBox = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    background: #f2f7fd;
    padding: 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
`;
